module.exports = __webpack_public_path__ + "img/icon.836170f3.png";